import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { DEFAULT_CONFIGS } from '@anm/data/hostingDefaults';
import getBestFitQuality from '@anm/helpers/getBestFitQuality';
import merge from 'lodash/merge';
import getVideoData from '../getVideoData';
import mapConfigs from '../mapConfigs';
import getBestQuality from '../getBestQuality';

var parseManifest = function parseManifest(manifestData, playerWidth) {
  var _manifestData$main = manifestData.main,
      main = _manifestData$main === void 0 ? [] : _manifestData$main,
      meta = manifestData.meta,
      mobile = manifestData.mobile,
      desktop = manifestData.desktop,
      uploadId = manifestData.uploadId,
      projectId = manifestData.projectId,
      password = manifestData.password,
      isEmbedded = manifestData.isEmbedded,
      configsFromManifest = manifestData.configs;
  var configs = merge(DEFAULT_CONFIGS, configsFromManifest);
  var mediaObjects = {
    main: main,
    mobile: mobile,
    desktop: desktop
  };

  var _getVideoData = getVideoData(mediaObjects),
      audio = _getVideoData.audio,
      sources = _getVideoData.sources,
      posters = _getVideoData.posters,
      thumbnailsConfig = _getVideoData.thumbnailsConfig;

  var bestFitPosterQuality = getBestFitQuality({
    playerWidth: playerWidth,
    sources: posters,
    type: 'image'
  });
  var bestQualityPoster = getBestQuality(posters);
  var bestFitPoster = posters.filter(function (p) {
    return p.width === bestFitPosterQuality;
  })[0] || bestQualityPoster;
  var bestQualityVideoSource = getBestQuality(sources);
  var bestQualityVideo = bestQualityVideoSource === null || bestQualityVideoSource === void 0 ? void 0 : bestQualityVideoSource.path;
  var width = (bestQualityVideoSource === null || bestQualityVideoSource === void 0 ? void 0 : bestQualityVideoSource.width) || (bestFitPoster === null || bestFitPoster === void 0 ? void 0 : bestFitPoster.width);
  var height = (bestQualityVideoSource === null || bestQualityVideoSource === void 0 ? void 0 : bestQualityVideoSource.height) || (bestFitPoster === null || bestFitPoster === void 0 ? void 0 : bestFitPoster.height);
  var parsedConfigs = mapConfigs(configs, sources);

  var customConfigs = _objectSpread(_objectSpread({}, parsedConfigs), thumbnailsConfig);

  var poster = !posters.length ? '' : bestFitPoster === null || bestFitPoster === void 0 ? void 0 : bestFitPoster.path;
  return {
    meta: meta,
    audio: audio,
    sources: sources,
    configs: configs,
    uploadId: uploadId,
    projectId: projectId,
    isEmbedded: isEmbedded,
    customConfigs: customConfigs,
    bestQualityVideo: bestQualityVideo,
    sizes: {
      width: width,
      height: height
    },
    poster: {
      posterUrl: poster
    },
    password: {
      password: password.hash,
      isEnabled: password.isEnabled,
      description: password.description
    }
  };
};

export default parseManifest;